import { useEffect, useMemo } from "react";

const KEY = "page";

/**
 * Injects (or replaces) the single page-level JSON-LD block.
 * Dedupes against any block the build-time prerender already emitted with the
 * same `data-seo` key, so crawlers never see two copies of the same entity
 * (which triggers errors like "Review has multiple aggregate ratings").
 */
export default function JsonLd({ data }) {
  const json = useMemo(() => (data ? JSON.stringify(data) : null), [data]);
  useEffect(() => {
    // Drop any pre-existing page-level JSON-LD (prerendered or stale) first.
    document.querySelectorAll(`script[data-seo="${KEY}"]`).forEach((n) => n.remove());
    if (!json) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-seo", KEY);
    el.text = json;
    document.head.appendChild(el);
    return () => el.remove();
  }, [json]);
  return null;
}
